import { computed } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { PurchasedItem, PurchasedItemType } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";
import { isMediaFile } from "@/lib/fileHelpers";

export default function usePurchasedItem(item: PurchasedItem) {
  const isRichText = computed(() => item.subject.subjectType === PurchasedItemType.RICH_TEXT_POST);
  const isMediaPost = computed(() => item.subject.subjectType === PurchasedItemType.MEDIA_POST);
  const isMessageAttachment = computed(() => item.subject.subjectType === PurchasedItemType.MESSAGE_ATTACHMENT);

  const coverFile = computed<FileData | undefined | null>(() => {
    if (isRichText.value) return item.coverFile;
    return item.files.find(i => isMediaFile(i));
  });

  return { isRichText, isMediaPost, isMessageAttachment, coverFile };
}
